import React from 'react';

import cx from 'classnames';
import { Arrow, ToggleLayer } from 'react-laag';

import { DEFAULT_NOTIFICATION_KEYS } from 'components/Pages/GuestPortal/LandingLayout/constants';
import Dropdown from 'components/shared/Dropdown';
import Icon from 'components/shared/Icon';
import Alert from 'components/shared/Icon/icons/Alert';
import Close from 'components/shared/Icon/icons/Close';

import styles from '../../../../Modal/index.module.css';
import commonStyles from '../index.module.css';
import { useNotificationCenter } from './functions';
import s from './index.module.css';
import { INotificationComponentProps, ICloseButtonProps, IUseNotificationCenterParams } from './types';
import OfflineMode from './Types/OfflineMode';

function NotificationCenter({ notifications = [] }: IUseNotificationCenterParams) {
  const { showBadge, showPopup, notificationToShow, handleToggleShowPopup } = useNotificationCenter({ notifications });

  return (
    <ToggleLayer
      fixed
      isOpen={showPopup}
      renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
        isOpen && (
          <div
            ref={layerProps.ref}
            className="layer"
            style={{
              ...layerProps.style,
              left: layerProps.style.left,
              zIndex: 9999,
            }}
          >
            <Dropdown className={'custom-right-header-dropdown'}>
              <NotificationComponent id={notificationToShow?.id} onRead={handleToggleShowPopup} />
              <CloseButton onClick={() => handleToggleShowPopup(false)} />
            </Dropdown>
            <Arrow
              style={{ ...arrowStyle, zIndex: '9' }}
              layerSide={layerSide}
              borderWidth={1}
              borderColor="rgba(0, 0, 0, 0.04)"
              backgroundColor="#fff"
              angle={40}
              roundness={0.5}
              size={12}
            />
          </div>
        )
      }
      placement={{
        anchor: 'BOTTOM_CENTER',
        autoAdjust: true,
        triggerOffset: 10,
      }}
    >
      {({ triggerRef }) => {
        return (
          <div className={s.alertWrapper} ref={triggerRef} onClick={() => handleToggleShowPopup(false)}>
            <Icon component={Alert} className={cx(commonStyles.icon, s.alertIcon, 'custom-right-alert')} />
            {showBadge && <div className={cx(s.badge, 'custom-notification-badge')} />}
          </div>
        );
      }}
    </ToggleLayer>
  );
}

export default NotificationCenter;

function NotificationComponent({ id, onRead }: INotificationComponentProps) {
  switch (id) {
    case DEFAULT_NOTIFICATION_KEYS.OFFLINE_MODE:
      return <OfflineMode onRead={onRead} />;
    default:
      return null;
  }
}

function CloseButton({ onClick }: ICloseButtonProps) {
  return (
    <button type="button" className={cx(styles.modalClose, 'custom-modal-close-btn')} tabIndex={0} onClick={onClick}>
      <Icon component={Close} className={cx(styles.closeIcon, 'custom-modal-close-icon')} fill="#3E3E40" />
    </button>
  );
}
